import { useState } from 'react'
import classes from './ChatWidget.module.scss'
import { ChatCoupon } from './types'
import { IconTag } from './icons'

interface Props {
  coupons: ChatCoupon[]
}

/**
 * Kullanılabilir kampanya kuponları kartı: kupon kodu + kampanya adı/açıklaması.
 * Kod sepette elle girildiği için satır bazında kopyalama sunar (bkz. BankAccountsCard).
 * Ad/açıklama backend'de boş kalabilir → yalnız dolu alanlar çizilir.
 */
export default function CouponCards({ coupons }: Props) {
  const [copied, setCopied] = useState<{ code: string; failed: boolean } | null>(null)

  if (coupons.length === 0) return null

  async function copyCode(code: string) {
    try {
      await navigator.clipboard.writeText(code)
      setCopied({ code, failed: false })
    } catch {
      setCopied({ code, failed: true })
    }
    window.setTimeout(() => setCopied(current => (current?.code === code ? null : current)), 2000)
  }

  return (
    <div className={classes.couponList}>
      {coupons.map((coupon, index) => {
        const isCopied = copied?.code === coupon.code

        return (
          <div key={`${coupon.code}-${index}`} className={classes.couponCard}>
            <div className={classes.couponHead}>
              <span className={classes.couponCodeBadge}>
                <IconTag />
                <span className={classes.couponCode}>{coupon.code}</span>
              </span>
              <button
                type='button'
                className={classes.couponCopyBtn}
                onClick={() => copyCode(coupon.code)}
                aria-label={`${coupon.code} kupon kodunu kopyala`}
              >
                {isCopied ? (copied?.failed ? 'Kopyalanamadı' : 'Kopyalandı') : 'Kopyala'}
              </button>
            </div>

            {coupon.campaignName && <div className={classes.couponName}>{coupon.campaignName}</div>}
            {coupon.description && <p className={classes.couponDesc}>{coupon.description}</p>}
          </div>
        )
      })}
    </div>
  )
}
